/**
 * Formatage monétaire **déterministe** pour les tableaux tarifaires.
 *
 * Volontairement pas de `Intl.NumberFormat` / `toLocaleString` : le résultat
 * dépend des données ICU de l'environnement, et un écart serveur ↔ navigateur
 * produit un mismatch d'hydratation sur des chaînes rendues côté serveur. Ici
 * la sortie ne dépend que de l'entrée.
 *
 * Séparateur : espace insécable étroite (U+202F), la convention typographique
 * française, qui évite aussi une coupure de ligne au milieu d'un montant.
 */
const NNBSP = " ";

/** `1540` → `1 540 €` · `80` → `80 €` (séparateur insécable). */
export const formatEuro = (amount: number): string => {
  const rounded = Math.round(amount);
  const digits = String(Math.abs(rounded));
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, NNBSP);
  return `${rounded < 0 ? "-" : ""}${grouped}${NNBSP}€`;
};

/** `2.6` → `2,60 €` — deux décimales, virgule décimale (prix au kilomètre). */
export const formatEuroPerKm = (amount: number): string =>
  `${amount.toFixed(2).replace(".", ",")}${NNBSP}€`;
